import { Suspense, lazy } from "react";
import { Outlet } from "react-router-dom";

// Lazy load AuthProvider to keep Supabase out of landing page bundle
const AuthProvider = lazy(() => 
  import("@/contexts/AuthContext").then(mod => ({ default: mod.AuthProvider }))
);

const AuthLayoutLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <div className="animate-pulse text-muted-foreground">Carregando...</div>
  </div>
);

export const AuthLayout = () => (
  <Suspense fallback={<AuthLayoutLoader />}>
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  </Suspense>
);
